import { render, staticRenderFns } from "./PainterMakeOrder.vue?vue&type=template&id=2a8308a1&scoped=true"
import script from "./PainterMakeOrder.vue?vue&type=script&lang=js"
export * from "./PainterMakeOrder.vue?vue&type=script&lang=js"
import style0 from "./PainterMakeOrder.vue?vue&type=style&index=0&id=2a8308a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8308a1",
  null
  
)

export default component.exports